/*
 * Copyright (c) 2026 Joseph Duggan. All rights reserved.
 */

import { appPalette } from '@sidekick/design-tokens';

const p = appPalette;

export interface EnergyDialProps {
  label: string;
  value: number;
  onChange: (next: number) => void;
}

/**
 * Five-point dial for one energy axis (physical / mental / emotional).
 * Maps to the runMorningWithAdapters input — values 1–5. Used at the
 * top of The Letter before generating the brief.
 */
export function EnergyDial({ label, value, onChange }: EnergyDialProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'baseline', gap: 14 }}>
      <span style={{ width: 110, fontSize: 13, color: p.fg }}>{label}</span>
      <div style={{ display: 'flex', gap: 6 }}>
        {[1, 2, 3, 4, 5].map((n) => {
          const active = n === value;
          return (
            <button
              key={n}
              type="button"
              onClick={() => onChange(n)}
              style={{
                width: 30,
                height: 30,
                border: `1px solid ${active ? p.fg : p.line}`,
                background: active ? p.fg : 'transparent',
                color: active ? p.bg : p.fg,
                fontFamily: 'var(--font-mono)',
                fontSize: 12,
                padding: 0,
              }}
              aria-label={`${label} ${n}`}
              aria-pressed={active}
            >
              {n}
            </button>
          );
        })}
      </div>
    </div>
  );
}
